import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import api from "../lib/api";
import { toast } from "sonner";
import { MessageSquarePlus, User, Clock } from "lucide-react";

export default function NotesModal({ open, onOpenChange, customer, onCountChange }) {
  const [notes, setNotes] = useState([]);
  const [text, setText] = useState("");

  const load = async () => {
    if (!customer) return;
    const { data } = await api.get(`/customers/${customer.id}/notes`, { silent: true });
    setNotes(data);
    onCountChange && onCountChange(customer.id, data.length);
  };

  useEffect(() => { if (open) { setText(""); load(); } /* eslint-disable-next-line */ }, [open, customer]);

  const add = async () => {
    if (!text.trim()) return;
    await api.post(`/customers/${customer.id}/notes`, { text });
    setText("");
    await load();
    toast.success("NOT EKLENDİ");
  };

  const firma = customer?.data?.firma || "";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex max-h-[88vh] max-w-2xl flex-col overflow-hidden border-slate-700 bg-slate-900 text-slate-100">
        <DialogHeader>
          <DialogTitle className="font-head">NOTLAR · {firma} <span className="ml-1 text-sm font-normal text-slate-500">({notes.length})</span></DialogTitle>
        </DialogHeader>
        <div className="space-y-2">
          <Textarea data-testid="note-textarea" value={text} onChange={(e) => setText(e.target.value)} placeholder="MÜŞTERİ GÖRÜŞME NOTU YAZIN... (SINIRSIZ)" className="min-h-[90px] border-slate-700 bg-slate-800 text-slate-100" />
          <Button data-testid="note-add-button" onClick={add} className="bg-blue-600 text-white hover:bg-blue-700"><MessageSquarePlus className="mr-1 h-4 w-4" /> NOT EKLE</Button>
        </div>
        <div className="mt-3 flex-1 space-y-2 overflow-y-auto pr-1">
          {notes.length === 0 && <div className="py-8 text-center text-slate-500">HENÜZ NOT YOK</div>}
          {notes.map((n) => (
            <div key={n.id} data-testid="note-item" className="rounded-lg border border-slate-800 bg-slate-800/40 p-3">
              <div className="whitespace-pre-wrap break-words text-sm text-slate-100">{n.text}</div>
              <div className="mt-2 flex items-center gap-4 text-xs text-slate-500">
                <span className="flex items-center gap-1"><User className="h-3 w-3" /> {n.author || "—"}</span>
                <span className="flex items-center gap-1"><Clock className="h-3 w-3" /> {new Date(n.created_at).toLocaleString("tr-TR")}</span>
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
